import React from 'react';
import { Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

// True inside the iOS / Android Capacitor shell (App Store build), false on the web.
// Falls back to the User-Agent marker set via capacitor.config.json "appendUserAgent".
export const isNativeApp = () => {
  try { if (Capacitor.isNativePlatform()) return true; } catch { /* no bridge */ }
  return typeof navigator !== 'undefined' && /CivilXNative/.test(navigator.userAgent || '');
};

// App Store guideline 3.1.1: no business/organization sign-up or external purchase flows in the native app.
export const WebOnly = ({ children, to = '/login' }) => (isNativeApp() ? <Navigate to={to} replace /> : children);

// Public web origin for shareable links (in the bundled native shell window.location is capacitor://localhost).
export const publicOrigin = () => {
  if (isNativeApp()) return (process.env.REACT_APP_BACKEND_URL || 'https://civilxtms.com').replace(/\/$/, '');
  return window.location.origin;
};
